export default "__VITE_PUBLIC_ASSET__296f612c__"